<template>
  <LayoutBasic :showLinksMenu="false">
    <!-- Título del drawer -->
    <template v-slot:title>
      <v-list-item @click="$router.push('/')" class="hoverable">
        <v-list-item-icon>
          <v-icon large>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="title font-weight-bold"
            >Inicio</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>

    <!-- Encabezado principal -->
    <template v-slot:navigation-title>Contabilidad</template>

    <!-- Accesos laterales -->
    <template v-slot:navigation-after-links>
      <v-list dense nav>
        <v-list-item class="hoverable">
          <v-list-item-icon
            ><v-icon>mdi-file-document</v-icon></v-list-item-icon
          >
          <v-list-item-content>
            <v-list-item-title>Sucursales</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'empresa.contabilidad.configuracion' }"
          class="hoverable"
        >
          <v-list-item-icon><v-icon>mdi-cog-outline</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Configuración</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'empresa.contabilidad.lineas' }"
          class="hoverable"
        >
          <v-list-item-icon><v-icon>mdi-shape-outline</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Líneas de negocio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'empresa.contabilidadPlanDeCuentas' }"
          class="hoverable"
        >
          <v-list-item-icon
            ><v-icon>mdi-file-document</v-icon></v-list-item-icon
          >
          <v-list-item-content>
            <v-list-item-title>Plan de cuentas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'empresa.contabilidadAsientos' }"
          class="hoverable"
        >
          <v-list-item-icon
            ><v-icon>mdi-file-document</v-icon></v-list-item-icon
          >
          <v-list-item-content>
            <v-list-item-title>Asientos tipo</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'empresa.contabilidadRubros' }"
          class="hoverable"
        >
          <v-list-item-icon
            ><v-icon>mdi-file-document</v-icon></v-list-item-icon
          >
          <v-list-item-content>
            <v-list-item-title>Rubros</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'empresa.contabilidad.balance-mensual' }"
          class="hoverable"
        >
          <v-list-item-icon
            ><v-icon>mdi-file-document</v-icon></v-list-item-icon
          >
          <v-list-item-content>
            <v-list-item-title>Reporte</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'empresa.contabilidadFormasDePago' }"
          class="hoverable"
        >
          <v-list-item-icon
            ><v-icon>mdi-file-document</v-icon></v-list-item-icon
          >
          <v-list-item-content>
            <v-list-item-title>Formas de pago</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'empresa.contabilidad.contribuyentes' }"
          class="hoverable" >
          <v-list-item-icon
            ><v-icon>mdi-file-document</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Contribuyentes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <!-- Contenido principal -->
    <template v-slot:vista-previa>
      <!-- La pantalla de configuración debe verse aunque no exista plan de cuentas -->
      <router-view
        v-if="
          planDeCuentas.length ||
          $route.name === 'empresa.contabilidad.configuracion'
        "
        :planDeCuentas="planDeCuentas"
      />
      <v-row v-else justify="center">
        <v-col cols="8">
          <v-list>
            <v-skeleton-loader
              v-for="i in 6"
              :key="i"
              max-height="350"
              type="list-item-avatar"
            ></v-skeleton-loader>
          </v-list>
        </v-col>
      </v-row>
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "EmpresaContabilidadLayout",
  components: { LayoutBasic },
  computed: {
    ...mapState("contabilidad", ["planDeCuentas"]),
  },
  methods: {
    ...mapActions("contabilidad", ["fetchPlanDeCuentas"]),
    async fetchCuentas() {
      try {
        await this.fetchPlanDeCuentas({ empresaUuid: null, isActive: true });
      } catch (error) {
        console.error("Error al obtener el plan de cuentas:", error);
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "info",
          text: "Error al obtener el plan de cuentas",
          icon: "mdi-information",
          timeout: 3000,
        });
      }
    },
  },
  created() {
    this.fetchCuentas();
  },
};
</script>
